import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { OnDestroy } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { StorageService } from "../storage.service";

export function componentDestroyed(component: OnDestroy) {
  const oldNgOnDestroy = component.ngOnDestroy;
  const destroyed$ = new ReplaySubject<void>(1);
  component.ngOnDestroy = () => {
    oldNgOnDestroy.apply(component);
    destroyed$.next(undefined);
    destroyed$.complete();
  };
  return destroyed$;
}

export class BrowserDetect {
  browser: any;
  version: any;
  versionSearchString: any;

  dataBrowser = [
    { string: navigator.userAgent, subString: "Edge", identity: "Edge" },
    { string: navigator.userAgent, subString: "MSIE", identity: "IE" },
    { string: navigator.userAgent, subString: "Trident", identity: "IE" },
    { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
    { string: navigator.userAgent, subString: "Opera", identity: "Opera" },
    { string: navigator.userAgent, subString: "OPR", identity: "Opera" },
    { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
    { string: navigator.userAgent, subString: "Safari", identity: "Safari" },
  ];

  init() {
    this.browser = this.searchString(this.dataBrowser) || "Other";
    this.version =
      this.searchVersion(navigator.userAgent) ||
      this.searchVersion(navigator.appVersion) ||
      "Unknown";
  }

  searchString(data) {
    for (let i = 0; i < data.length; i++) {
      let dataString = data[i].string;
      this.versionSearchString = data[i].subString;

      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  }

  searchVersion(dataString) {
    let index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return;
    }

    let rv = dataString.indexOf("rv:");
    if (this.versionSearchString === "Trident" && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(
        dataString.substring(index + this.versionSearchString.length + 1)
      );
    }
  }
}

@Injectable()
export class ApplicationUtilsService {
  private verplichteVelden: any = null;
  private toevoegbareVelden: any = null;
  private verwijderbareVelden: any = null;
  private wijzigbareVelden: any = null;
  private verborgenVelden: any = null;

  private sectorParams = new Subject<any>();
  private sectorParamsObservable = this.sectorParams.asObservable();

  private prompts;
  private promptsEN;
  private promptsES;
  private sectorParameters;
  private actionIdentifiers;

  private loggedInUser: any;

  private appversion;
  private hostname;
  private beheermodus: boolean;
  private dbOmgeving;
  private dbOmgevingKleur;

  private initStatusses = [];
  private initStatussesHandelingenCount = 2;
  private language = "EN";
  private certificateNumber = "";
  private verificationNumber = "";
  private captchaInput = "";
  private resultaten;
  private resultatenOpgehaald = false;
  private resultaatError = null;

  private browser;

  public readonly POSITIVE_BTN = "positive";
  public readonly NEGATIVE_BTN = "negative";
  public readonly CLOSE_BTN = "close";
  public readonly BACKGROUND = "background";
  private covErrorMessages = {
    foutmelding: "",
    headerFoutmelding: "",
    foutmeldingOverig: "",
  };

  constructor(
    private httpClient: HttpClient,
    private localstorage: StorageService
  ) {
    this.getLanguageFromLocalStorage();
    this.addLanguageToUrl();
  }

  addLanguageToUrl() {
    // Toevoegen van de taal aan de url als er geen taal in de url aanwezig is.
    const pathNameWithoutSlashes = location.pathname.replace(/\//g, "");
    if (pathNameWithoutSlashes === this.getContextRoot()) {
      // Er zit geen taal in de url, dus deze toevoegen aan de url.
      // Deze taal komt uit de local storage. Als deze leeg is wordt de default (en) gebruikt.
      location.href =
        location.origin +
        "/cov" +
        "/" +
        this.language.toLowerCase() +
        this.getParams();
    } else {
      // De taal in de url is aangepast door de gebruiker.
      // Deze taal gebruiken in de pagina en opslaan in local storage
      const newLanguage = location.pathname.substr(5, 2).toUpperCase();
      if (newLanguage === "EN" || newLanguage === "ES") {
        this.language = newLanguage;
        this.localstorage.set("cov_stored_language", this.language);
      }
    }
  }

  getLanguageFromLocalStorage() {
    // Bepaal de taal welke is opgeslagen in local storage
    const cov_stored_language: string = this.localstorage.get(
      "cov_stored_language"
    );
    if (cov_stored_language != null && !(cov_stored_language == undefined)) {
      this.language = cov_stored_language;
    }
  }

  getParams() {
    const params = new URLSearchParams(location.search);
    if (params != null && params != undefined && params.toString().length > 0) {
      return "?" + params.toString();
    } else {
      return params;
    }
  }

  getCovErrorMessages() {
    if (this.language == "ES") {
      this.covErrorMessages.foutmelding = this.getPrompt(
        "COV_CERTIFICAAT.ERROR_ALG_ESP"
      );
      this.covErrorMessages.headerFoutmelding = this.getPrompt(
        "COV_CERTIFICAAT.ERROR_ALG_ESP_HEADER"
      );
      this.covErrorMessages.foutmeldingOverig = this.getPrompt(
        "COV_CERTIFICAAT.ERROR_OVERIG_ESP"
      );
    } else {
      this.covErrorMessages.foutmelding = this.getPrompt(
        "COV_CERTIFICAAT.ERROR_ALG_ENG"
      );
      this.covErrorMessages.headerFoutmelding = this.getPrompt(
        "COV_CERTIFICAAT.ERROR_ALG_ENG_HEADER"
      );
      this.covErrorMessages.foutmeldingOverig = this.getPrompt(
        "COV_CERTIFICAAT.ERROR_OVERIG_ENG"
      );
    }
    return this.covErrorMessages;
  }

  getContextRoot() {
    return "cov";
  }

  instantiateLogedInUser(): Observable<any> {
    return this.httpClient
      .post("/" + this.getContextRoot() + "/getLoggedInUser", null)
      .pipe(
        map((res: any) => {
          this.loggedInUser = res;
        }),
        catchError((error: any) => {
          return Observable.throw("Kon de applicatie niet initieren");
        })
      );
  }

  // prompts ophalen waarbij key=action-identifier en value=prompts
  private syncprompts(language: string): Observable<any> {
    return this.httpClient
      .post("/" + this.getContextRoot() + "/getPrompts", {
        eigenschap: "prompt",
        taal: language,
      })
      .pipe(
        map((res: any) => {
          if (language === "EN") {
            this.promptsEN = res;
            if (this.language === "EN") {
              this.prompts = this.promptsEN;
            }
          } else if (language === "ES") {
            this.promptsES = res;
            if (this.language === "ES") {
              this.prompts = this.promptsES;
            }
          }
        }),
        catchError((error: any) => {
          return Observable.throw("Kon de applicatie niet initieren");
        })
      );
  }

  getCovPrompts(prompts: any) {
    const covPrompts = [];
    prompts.forEach((prompt) => {
      if (prompt != null && prompt.subString(1, 3) === "COV") {
        covPrompts.push(prompt);
      }
    });
    return covPrompts;
  }

  public getPrompt(value) {
    if (
      typeof this.prompts[value] == "undefined" ||
      this.prompts[value] == null ||
      this.prompts[value] == ""
    ) {
      return value;
    }
    return this.prompts[value];
  }

  public getActionIdentifier(value) {
    if (
      typeof this.actionIdentifiers[value] == "undefined" ||
      this.actionIdentifiers[value] == null ||
      this.actionIdentifiers[value] == ""
    ) {
      return value;
    }
    return this.actionIdentifiers[value];
  }

  public async load() {
    return new Promise((resolve, reject) => {
      this.prompts = null;
      this.actionIdentifiers = null;

      /*
      this.instantiateLogedInUser()
			.catch((error: any):any => {
				if(this.processInitResult(false)){
					this.getInitResult(resolve, reject, error)
				}
      })
			.subscribe( (callResult) => {
        if(this.processInitResult(true)){
  				this.getInitResult(resolve, reject, null)
			}
      });
      */

      this.syncprompts("EN")
        .pipe(
          catchError((error: any): any => {
            if (this.processInitResult(false)) {
              this.getInitResult(resolve, reject, error);
            }
          })
        )
        .subscribe((callResult) => {
          if (this.processInitResult(true)) {
            this.getInitResult(resolve, reject, null);
          }
        });

      this.syncprompts("ES")
        .pipe(
          catchError((error: any): any => {
            if (this.processInitResult(false)) {
              this.getInitResult(resolve, reject, error);
            }
          })
        )
        .subscribe((callResult) => {
          if (this.processInitResult(true)) {
            this.getInitResult(resolve, reject, null);
          }
        });
      /*
            this.syncActionIdentifiers()
            .catch((error: any):any => {
                if(this.processInitResult(false)){
                    this.getInitResult(resolve, reject, null)
                }
            })
            .subscribe( (callResult) => {
                if(this.processInitResult(true)){
                    this.getInitResult(resolve, reject, null)
                }
            });
        */
    });
  }

  processInitResult(status) {
    this.initStatusses.push(status);
    return this.initStatusses.length == this.initStatussesHandelingenCount;
  }

  private getInitResult(resolve, reject, error) {
    let result = true;
    for (let index = 0; index < this.initStatusses.length; index++) {
      result = result && this.initStatusses[index];
    }
    result =
      result && this.initStatusses.length == this.initStatussesHandelingenCount;
    if (result) {
      // this.browserCheck(resolve, reject);
      resolve(true);
    } else {
      reject(false);
    }
  }

  public getLoggedInUser() {
    return this.loggedInUser;
  }

  public getdbOmgeving() {
    return this.dbOmgeving;
  }

  public getdbOmgevingKleur() {
    return this.dbOmgevingKleur;
  }

  getKolomActie(kolomIdentificatie: string, kolomActie: string) {
    switch (kolomActie) {
      case "verplicht":
        if (typeof this.verplichteVelden[kolomIdentificatie] != "undefined") {
          return this.verplichteVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "wijzigbaar":
        if (typeof this.wijzigbareVelden[kolomIdentificatie] != "undefined") {
          return this.wijzigbareVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "toevoegen":
        if (typeof this.toevoegbareVelden[kolomIdentificatie] != "undefined") {
          return this.toevoegbareVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "verwijderen":
        if (
          typeof this.verwijderbareVelden[kolomIdentificatie] != "undefined"
        ) {
          return this.verwijderbareVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "verbergen":
        if (typeof this.verborgenVelden[kolomIdentificatie] != "undefined") {
          return this.verborgenVelden[kolomIdentificatie];
        } else {
          return false;
        }
      default:
        return null;
    }
  }

  public getVersion() {
    return this.appversion;
  }

  public getHostname() {
    return this.hostname;
  }

  public getBeheermodus() {
    return this.beheermodus;
  }

  public getSectorParameter(param) {
    if (
      typeof this.sectorParameters[param] == "undefined" ||
      this.sectorParameters[param] == null ||
      this.sectorParameters[param] === ""
    ) {
      return null;
    }
    return this.sectorParameters[param];
  }

  getMimeType(extensie: string) {
    extensie = extensie.toLowerCase();
    switch (extensie) {
      case "xml":
        return "application/xml";
      case "pdf":
        return "application/pdf";
      case "doc":
        return "application/msword";
      case "docx":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "xls":
        return "application/vnd.ms-excel";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "png":
        return "image/png";
    }
  }

  isDisabled(ref_object: any, action_identifier: string) {
    let wijzigbaar: boolean = false;
    if (action_identifier != undefined) {
      wijzigbaar = this.getKolomActie(action_identifier, "wijzigbaar");
    }

    if (
      ref_object == undefined ||
      typeof ref_object.muteerbaar == "undefined"
    ) {
      return false;
    } else {
      return !ref_object.muteerbaar || (ref_object.eedOpSlot && !wijzigbaar);
    }
  }

  compareObjects(o, o2) {
    if (o == null || o2 == null) {
      return false;
    }
    const aantalkeys1 = Object.keys(o).length;
    const aantalkeys2 = Object.keys(o2).length;

    if (aantalkeys1 != aantalkeys2) {
      return false;
    }
    let returnvalue = true;
    Object.keys(o).forEach((k) => {
      let itsAMatch = o[k] == o2[k];

      if (
        o[k] != null &&
        typeof o[k] == "object" &&
        o2[k] != null &&
        typeof o2[k] == "object"
      ) {
        itsAMatch = JSON.stringify(o[k]) == JSON.stringify(o2[k]);
      }

      returnvalue = returnvalue && itsAMatch;
    });
    return returnvalue;
  }

  getLanguage() {
    return this.language;
  }

  setLanguage(language: string) {
    this.language = language;
    if (language === "EN") {
      this.prompts = this.promptsEN;
      document.querySelector("html").setAttribute("lang", "en");
    } else if (language === "ES") {
      this.prompts = this.promptsES;
      document.querySelector("html").setAttribute("lang", "es");
    }
    this.localstorage.set("cov_stored_language", this.language);
  }

  getCertificateNumber() {
    return this.certificateNumber;
  }

  setCertificateNumber(certificationNumber: string) {
    this.certificateNumber = certificationNumber;
  }

  getVerificationNumber() {
    return this.verificationNumber;
  }

  setVerificationNumber(verificationNumber: string) {
    this.verificationNumber = verificationNumber;
  }

  getCaptchaInput() {
    return this.captchaInput;
  }

  setCaptchaInput(captchaInput: string) {
    this.captchaInput = captchaInput;
  }

  getResultaten() {
    return this.resultaten;
  }

  setResultaten(resultaten: any) {
    this.resultaten = resultaten;
  }

  isResultatenOpgehaald() {
    return this.resultatenOpgehaald;
  }

  setResultatenOpgehaald(resultatenOpgehaald: boolean) {
    this.resultatenOpgehaald = resultatenOpgehaald;
  }

  getResultaatError() {
    return this.resultaatError;
  }

  setResultaatError(resultaatError: any) {
    this.resultaatError = resultaatError;
  }

  public getBrowser() {
    return this.browser;
  }
}
